(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
  }

  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerOverlay = document.querySelector('.header-overlay');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			if (this.headerIsAlwaysSticky) {
				this.header.classList.add('always-fixed');
				if (!this.headerOverlay) {
					this.header.classList.add('shopify-section-header-sticky');
					this.headerOverlay.classList.add('color-background-1');
					this.headerOverlay.classList.remove('color-inverse');
				}
			}

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
				this.header.style.transform = 'translateY(-100%)';
			};

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
				this.header.classList.remove('color-background-2');
				this.header.style.transition = 'background var(--duration-short)';
				this.header.style.transform = 'translateY(0)';
			};

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky');
				this.header.style.transform = 'translateY(0)';
				this.header.style.transition = 'background var(--duration-short)';
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-2');
				};
			};

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
			}
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;

			if (document.querySelector(".search-modal.active")) return;
			if (document.querySelector(".burger-drawer.active")) {
				this.header.classList.remove('shopify-section-header-hidden', 'animate');
			};
			if (document.querySelector(".burger-drawer.active")) return;
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
			}
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.headerOverlay) {
				this.headerOverlay.classList.remove('color-background-1');
				if (!this.classList.contains('mega-menu-open')) {
					this.headerOverlay.classList.add('color-inverse');
				}
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => {
					disclosure.close(); 
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
				if (this.disclosureLists) {
					this.disclosureLists.forEach(disclosureList => {
						disclosureList.setAttribute('hidden', true); 
					});
				}
			this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
			if (this.disclosureButton) {
				this.disclosureButton.forEach(disclosureButton => {
					disclosureButton.setAttribute('aria-expanded', false); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	window.addEventListener('DOMContentLoaded', () => {
		class ProductModal extends ModalDialog {
			constructor() {
				super();
			}

			hide() {
				super.hide();
				window.pauseAllMedia();
			}

			show(opener) {
				super.show(opener);
				//this.showActiveMedia();
				this.constProductPageSwiperCall();
			}

			showActiveMedia() {
				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				if (activeMedia) {
					activeMedia.classList.add('active');
					activeMedia.scrollIntoView();
				}
				
				if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
					activeMedia.loadContent();
			}
			constProductPageSwiperCall(showActiveMedia) {
					const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
					let activeMediaIndex = 0
					
					this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
							if(element == activeMedia){
								activeMediaIndex = index
							}
						}
					)
					const prodPageSwiper = new Swiper("#product-page-swiper", {
						zoom: false,
						centeredSlides: false,
						slidesPerView: 1,
						autoheight: true,
						watchSlidesVisibility: false,
						watchSlidesProgress: true,
						observer: true,
						observeParents: true,
						init: false,
						...(window.innerWidth >= 990 && {
							navigation: {
								nextEl: ".swiper-button-next-prod-page",
								prevEl: ".swiper-button-prev-prod-page",
							},
						}),
						
						//on: {
						//	click: function (e) {
						//			if (this.zoom.scale === 1) {
						//			this.zoom.in();
						//			} else {
						//				this.zoom.out();
						//			}
						//	 },
						//},
					});
					
						
					prodPageSwiper.on('init', function() {
						prodPageSwiper.slideTo(activeMediaIndex, 0, false);
					});
					prodPageSwiper.init()
					
					document.querySelector('.product-media-modal__toggle').addEventListener("click", function() { 
						if(prodPageSwiper && !prodPageSwiper.destroyed) {
							prodPageSwiper.destroy()
						}
						//prodPageSwiper.destroy() 
					});
					
				}
		}

		class ProductRecommendations extends HTMLElement {
			constructor() {
				super();

				const handleIntersection = (entries, observer) => {
					if (!entries[0].isIntersecting) return;
					observer.unobserve(this);

					fetch(this.dataset.url)
						.then(response => response.text())
						.then(text => {
							const html = document.createElement('div');
							html.innerHTML = text;
							const recommendations = html.querySelector('product-recommendations--single');
							if (recommendations && recommendations.innerHTML.trim().length) {
								this.innerHTML = recommendations.innerHTML;
							}
						})
						.catch(e => {
							console.error(e);
						});
				}

				new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
			}
		}

		customElements.define('product-modal', ProductModal);
		customElements.define('product-recommendations--single', ProductRecommendations);
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {



						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					


						var swiper = new Swiper(".swiper-container", {
							slidesPerView: 1,

								spaceBetween: 1,
								navigation: {
									nextEl: ".product-button-group .swiper-button-next-1",
									prevEl: ".product-button-group .swiper-button-prev-1",
								},
								pagination: {
									el: ".product-card-pagination",
									clickable: true,
								},
						});
						const initAnimated = () => {
							const blocks = document.querySelectorAll(".animated-block:not(.visible)");

							const observer = new IntersectionObserver(
									(entries) => {
											entries.forEach((entry) => {
													if (entry.isIntersecting) {
															const block = entry.target;
															block.classList.add("visible");
															observer.unobserve(block);
													}
											});
									},
									{ threshold: 0.1 } 
							);

							blocks.forEach((block) => {
									observer.observe(block);
							});
						};
						initAnimated();
						const cursorProgress = (productSwiper) => {
							const cursor = productSwiper.querySelector(".product__cursor");
							const cursorIcon = productSwiper.querySelector("#cursor-icon1");
						
							const animateCursor = (e) => {
								const contentRect = productSwiper.getBoundingClientRect();
								const x = e.clientX - contentRect.left - 12;
								const y = e.clientY - contentRect.top - 12;
						
								cursor.animate(
									{ transform: `translate(${x}px, ${y}px)` },
									{ duration: 300, fill: "forwards" }
								);
							};
						
							const getCursorClass = (position, width) => {
								return position < width / 2 ? "prev" : "next";
							};
						
							productSwiper.addEventListener("mousemove", (e) => {
								if (!e.target.closest(".link") &&
				!e.target.closest(".swiper-pagination") ) {
					cursor.classList.add("active");
				} else {
					cursor.classList.remove("active");
				}


								
						
								animateCursor(e);
						
								const position = e.clientX - productSwiper.getBoundingClientRect().left;
								cursor.dataset.type = getCursorClass(position, productSwiper.clientWidth);
						
								cursorIcon.className = cursor.dataset.type; 
						
								
							});
						
							productSwiper.addEventListener("mouseleave", () => {
								cursor.classList.remove("active");
							});
						};
						
		
							const productCards = document.querySelectorAll(".card--product_cursor");
							productCards.forEach((productCard) => cursorProgress(productCard));
							const buttonHoverEffects= () => {
	
	if (window.innerWidth < 1200) return;
	function wrapLetters(element) {
			const text = element.textContent.trim();
			element.innerHTML = '';

			const wrapperSpan = document.createElement('span');
			wrapperSpan.className = 'wrapper';

			Array.from(text).forEach((char, charIndex) => {
					const charSpan = document.createElement('span');
					charSpan.className = 'char';
					charSpan.textContent = char;
					charSpan.style.setProperty('--char-index', charIndex + 1);
					wrapperSpan.appendChild(charSpan);
			});

			element.appendChild(wrapperSpan);
	}

	document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);
}

buttonHoverEffects()

					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();
})();
